module.exports = __webpack_public_path__ + "assets/img/6-4.5d9c7164.png";